"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const INIT_STATE = {
    isLoaderCount: 0,
    selectedService: {},
    modules: [],
    selectedCorporate: null,
    selectedNotification: [],
};
exports.default = (state = INIT_STATE, action) => {
    switch (action.type) {
        case "TOGGLE_STATE": {
            return Object.assign({}, state, { toggle: action.payload });
        }
        case "EXPORT_OBJECT": {
            return Object.assign({}, state, { exportObject: action.payload });
        }
        case "CHANGE_VIEW": {
            return Object.assign({}, state, { view: action.payload });
        }
        case "CHANGE_PASSWORD": {
            return Object.assign({}, state, { isChangePasswordVisible: action.payload });
        }
        case "CONFIRMATION_DIALOG": {
            return Object.assign({}, state, { confirmationDialog: action.payload });
        }
        case "TIME_PICKER": {
            return Object.assign({}, state, { timePicker: action.payload });
        }
        case "TOGGLE_LOADER": {
            var counter = state.isLoaderCount;
            if (action.payload) {
                counter++;
            }
            else {
                counter--;
            }
            if (counter <= 0) {
                return Object.assign({}, state, { isLoaderCount: 0, isLoading: false });
            }
            else {
                return Object.assign({}, state, { isLoaderCount: counter, isLoading: true });
            }
            // return {
            //   ...state,
            //   isLoading: action.payload
            // };
        }
        case "TOGGLE_LOADER_CLEAR": {
            console.log("clear");
            return Object.assign({}, state, { isLoaderCount: 0, isLoading: false });
        }
        case "SERVICE_LIST": {
            return Object.assign({}, state, { modules: action.payload });
        }
        case "SELECTED_SERVICE": {
            return Object.assign({}, state, { selectedService: action.payload });
        }
        case "SELECTED_CORPORATE": {
            return Object.assign({}, state, { selectedCorporate: action.payload });
        }
        case "TOGGLE_LOADER_MULTI": {
            var count = state.isLoadingCount;
            if (action.payload) {
                count++;
            }
            else {
                count--;
            }
            if (count <= 0) {
                return Object.assign({}, state, { isLoadingCount: 0, isLoading: false });
            }
            else {
                return Object.assign({}, state, { isLoadingCount: count, isLoading: true });
            }
        }
        case "SELECTED_NOTIFICATION": {
            return Object.assign({}, state, { selectedNotification: action.payload });
        }
        default:
            return state;
    }
};
//# sourceMappingURL=setting.js.map